"use client";

import React from "react";
import GenericLazyLoader from "@/components/common/generic-lazy-loader";
import { BrochureSection } from "@/types/dto/destinations-page/destination-page-types";

interface BrochureSectionProps {
  brochureSection: BrochureSection;
}


const LazyLoadBrochureSection = ({ brochureSection }: BrochureSectionProps) => 

    <GenericLazyLoader
      importComponent={() => import("./brochure-section")}
      componentProps={{ brochureSection }}
      debugName="Brochure Section"
      threshold={0.1}
      rootMargin="200px 0px"
    />;


export default LazyLoadBrochureSection;